import {useDefault, useFirst} from '../../../common/common';
import {ClassicStayPreferences} from "../../model/reservation/stay-preferences/classic-stay-preferences.model";

export class StayPreferenceRequestBuilder {
  private _model: ClassicStayPreferences;
  constructor() {
    this._model = new ClassicStayPreferences();
  }

  withPreferences(stayPreferencesInfo: any): StayPreferenceRequestBuilder {
    let preferences = [];
    for (let i = 0; i < stayPreferencesInfo.stayPreferences.length; i++){
      let preference = {
        name:stayPreferencesInfo.stayPreferences[i].id,
        description: stayPreferencesInfo.stayPreferences[i].name,
        preferences: [],
      };
      for (let j = 0; j < stayPreferencesInfo.stayPreferences[i].preferences.length; j++){
        let options = {
          name:stayPreferencesInfo.stayPreferences[i].preferences[j].id,
          description:stayPreferencesInfo.stayPreferences[i].preferences[j].name,
          type:stayPreferencesInfo.stayPreferences[i].preferences[j].type,
          options:[],
          userPrefSelected: stayPreferencesInfo.stayPreferences[i].preferences[j].userPrefSelected,
          preferenceValue: stayPreferencesInfo.stayPreferences[i].preferences[j].preferenceValue
        };
        for (let k = 0; k < stayPreferencesInfo.stayPreferences[i].preferences[j].options.length; k++){
          let option = {
            id:stayPreferencesInfo.stayPreferences[i].preferences[j].options[k].id,
            name:stayPreferencesInfo.stayPreferences[i].preferences[j].options[k].name,
            selected:stayPreferencesInfo.stayPreferences[i].preferences[j].options[k].selected
          };
          options.options.push(option);
        }
        preference.preferences.push(options);
      }
      preferences.push(preference);
    }

    const stayPreferencesData = [{categories:preferences}];

    this._model.categories = useDefault(stayPreferencesData, null);
    return this;
  }

  build(): ClassicStayPreferences {
    return this._model;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/stay-preference-request.builder.ts